export default __webpack_public_path__ + "static/media/imageBannerFinal.150b13b0.png";